import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import AdminLayout from './layouts/AdminLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Departments from './pages/Departments';
import Doctors from './pages/Doctors';
import Registrations from './pages/Registrations';
import TodayRegs from './pages/TodayRegs';
import Products from './pages/Products';
import Categories from './pages/Categories';
import Accounts from './pages/Accounts';
import Roles from './pages/Roles';
import Menus from './pages/Menus';
import Banners from './pages/Banners';
import Contents from './pages/Contents';
import Stores from './pages/Stores';
import Orders from './pages/Orders';
import PointsMall from './pages/PointsMall';
import PointsAccounts from './pages/PointsAccounts';
import PointsRedemptions from './pages/PointsRedemptions';
import Distributors from './pages/Distributors';
import Referrals from './pages/Referrals';
import Commissions from './pages/Commissions';
import Withdraws from './pages/Withdraws';
import Feedbacks from './pages/Feedbacks';
import Users from './pages/Users';
import NotFound from './pages/NotFound';
import { getToken } from './utils/request';

// 图片兜底占位（灰底）：URL 失效/被删除时不再显示浏览器裂图，全局挂到 ConfigProvider，
// 所有 antd Image（订单凭证、售后图、轮播图、商品图、兑换商品图）统一生效
const IMG_PLACEHOLDER =
  'data:image/svg+xml;charset=utf-8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160">' +
      '<rect width="160" height="160" fill="#f0f0f0" />' +
      '<text x="80" y="84" font-size="12" fill="#bfbfbf" text-anchor="middle">图片加载失败</text>' +
      '</svg>',
  );

// 登录守卫：无 token 跳转登录页
const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (!getToken()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <ConfigProvider
      locale={zhCN}
      theme={{ token: { colorPrimary: '#065F46' } }}
      image={{ fallback: IMG_PLACEHOLDER }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <RequireAuth>
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/departments" element={<Departments />} />
            <Route path="/doctors" element={<Doctors />} />
            <Route path="/today-regs" element={<TodayRegs />} />
            <Route path="/registrations" element={<Registrations />} />
            <Route path="/products" element={<Products />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/accounts" element={<Accounts />} />
            <Route path="/roles" element={<Roles />} />
            <Route path="/menus" element={<Menus />} />
            <Route path="/banners" element={<Banners />} />
            <Route path="/contents" element={<Contents />} />
            <Route path="/stores" element={<Stores />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/points-mall" element={<PointsMall />} />
            <Route path="/points-accounts" element={<PointsAccounts />} />
            <Route path="/points-redemptions" element={<PointsRedemptions />} />
            <Route path="/distributors" element={<Distributors />} />
            <Route path="/referrals" element={<Referrals />} />
            <Route path="/commissions" element={<Commissions />} />
            <Route path="/withdraws" element={<Withdraws />} />
            <Route path="/feedbacks" element={<Feedbacks />} />
            <Route path="/users" element={<Users />} />
            {/* 未匹配路径兜底：留在后台布局内展示 404，避免整页空白 */}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
};

export default App;
